import { Component, input, output } from '@angular/core';
import { MatListOption, MatSelectionList, MatSelectionListChange } from '@angular/material/list';
import { LFProject } from '@lfw/roesberg.liveforms.core';
import { TranslatePipe } from '@ngx-translate/core';
import { SelectionType } from '../../../shared/enums/selection-type';
import { SelectionArguments } from '../../../shared/models/selection-arguments';
import { ProjectListItemComponent } from '../project-list-item/project-list-item.component';

@Component({
  selector: 'lfw-project-list-view',
  templateUrl: './project-list-view.component.html',
  styleUrls: ['./project-list-view.component.css'],
  imports: [MatSelectionList, MatListOption, ProjectListItemComponent, TranslatePipe]
})
export class ProjectListViewComponent {
  readonly data = input<LFProject[]>();
  readonly itemSelected = output<SelectionArguments>();

  isLoaded(): boolean {
    return this.data() != undefined;
  }

  hasData(): boolean {
    return this.data() != undefined && this.data()!.length > 0;
  }

  onSelection(event: MatSelectionListChange): void {
    const selected = event.options[0].value;
    if (selected != undefined) {
      const args = new SelectionArguments();
      args.id = selected;
      args.action = SelectionType.Selected;
      this.itemSelected.emit(args);
    }
  }
}
